import { createContext } from "react";

const GlobalContext = createContext({
	breakpoint: () => {},
	isLoading: "",
	setIsLoading: () => {},
	isAuthenticated: "",
	setIsAuthenticated: () => {},
	user: undefined,
	setUser: () => {},
	updateUser: () => {},
	token: "",
	setToken: () => {},
	verifyUser: () => {},
	axiosInstance: undefined,
	applications: [],
	setApplications: () => {},
	getAllApplications: () => {},
	createNewApplication: () => {},
	updateApplication: () => {},
	deleteApplication: () => {},
	people: [],
	setPeople: () => {},
	getAllPeople: () => {},
	addNewMember: () => {},
	updateMember: () => {},
	removeMember: () => {},
	team: [],
	setTeam: () => {},
	restructureTeam: () => {},
});

export default GlobalContext;
